import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "result-template" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Rever feedback", -1)
const _hoisted_3 = { id: "result" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "50%" }, "Tiêu chí"),
  /*#__PURE__*/_createElementVNode("th", null, "Kết quả")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Bạn có sẵn sàng giới thiệu Rever cho người khác?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "Bạn có thấy Rever.vn dễ sử dụng không?", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "Bạn muốn Rever.vn cần cải thiện thêm về điều gì?", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "other" }, "Ý kiến khác:", -1)
const _hoisted_16 = { class: "msg" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", { style: {"margin-bottom":"10px"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "From:")
], -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", null, "Name", -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "Phone number", -1)
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("b", null, "Email", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", null, "IP", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("b", null, "Page Url", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", null, "User Agent", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tr", null, [
        _hoisted_5,
        _createElementVNode("td", null, _toDisplayString($props.step1.rate) + "/10", 1)
      ]),
      _createElementVNode("tr", null, [
        _hoisted_6,
        ($props.step2.rate == $options.UX.NORMAL)
          ? (_openBlock(), _createElementBlock("td", _hoisted_7, "Bình thường"))
          : _createCommentVNode("", true),
        ($props.step2.rate == $options.UX.HARD)
          ? (_openBlock(), _createElementBlock("td", _hoisted_8, "Khó sử dụng"))
          : _createCommentVNode("", true),
        ($props.step2.rate == $options.UX.EASY)
          ? (_openBlock(), _createElementBlock("td", _hoisted_9, "Dễ sử dụng"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("tr", null, [
        _hoisted_10,
        _createElementVNode("td", null, [
          ($props.step3.improve.ui)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, "+ Giao diện đẹp hơn"))
            : _createCommentVNode("", true),
          ($props.step3.improve.content)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, "+ Nội dung chính xác hơn"))
            : _createCommentVNode("", true),
          ($props.step3.improve.feature)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, "+ Thêm tính năng"))
            : _createCommentVNode("", true),
          ($props.step3.improve.other)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("p", _hoisted_16, _toDisplayString($props.step3.otherMsg), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_17,
    ($props.name)
      ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
          _createTextVNode(" + "),
          _hoisted_19,
          _createTextVNode(": " + _toDisplayString($props.name), 1)
        ]))
      : _createCommentVNode("", true),
    ($props.phone)
      ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
          _createTextVNode(" + "),
          _hoisted_21,
          _createTextVNode(": " + _toDisplayString($props.phone), 1)
        ]))
      : _createCommentVNode("", true),
    ($props.email)
      ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
          _createTextVNode(" + "),
          _hoisted_23,
          _createTextVNode(": " + _toDisplayString($props.email), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, [
      _createTextVNode(" + "),
      _hoisted_24,
      _createTextVNode(": " + _toDisplayString($props.ip), 1)
    ]),
    _createElementVNode("p", null, [
      _createTextVNode(" + "),
      _hoisted_25,
      _createTextVNode(": " + _toDisplayString($props.pageUrl), 1)
    ]),
    _createElementVNode("p", null, [
      _createTextVNode(" + "),
      _hoisted_26,
      _createTextVNode(": " + _toDisplayString($props.userAgent), 1)
    ])
  ]))
}